import ZUX from "@/modules/ZUX";
import Vue from "vue";
import BasketSlideOut from "@/components/BasketSlideOut.vue";
import BasketDot from "@/components/BasketDot.vue";
import BillPay from "@/components/BillPay.vue";
import WineList from "./WineList.vue";
import WishList from "./WishList.vue";

// import AccountMenu from '@/components/AccountMenu.vue';

import LoginForm from "@/components/LoginForm.vue";
import RegistrationForm from "@/components/RegistrationForm.vue";
import TradeRegistrationForm from "@/components/TradeRegistrationForm.vue";
import ProductFormatFull from "@/components/ProductFormatFull.vue";
import ProductFormatTrade from "@/components/ProductFormatTrade.vue";
import ProductTechnicalInfo from "@/components/ProductTechnicalInfo.vue";
import WishlistAddButton from "@/components/WishlistAddButton.vue";
import Search from "./Search.vue";
import Common from "./views/Common.vue";
import store from "./store";
import router from "./router/search";
import wineListRouter from "./router/winelist";
import Skeleton from "vue-loading-skeleton";

import Utils from "./utils";
import BasketTimer from "./basket-timer";

window.ZUX = ZUX;

Vue.config.productionTip = false;

Vue.use(Skeleton);

Vue.use(Utils);

store.commit("basket/set_adding_state", false);

if (document.getElementById("app-basket")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    render: h => h(BasketSlideOut)
  }).$mount("#app-basket");
}

if (document.getElementById("app-search")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    router,
    render: h => h(Search)
  }).$mount("#app-search");
}

if (document.getElementById("app-billpay")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    router,
    render: h => h(BillPay)
  }).$mount("#app-billpay");
}

if (document.getElementById("app-login")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    router,
    render: h =>
      h(LoginForm, {
        props: {
          showButton: document.getElementById("app-login").attributes[
            "show-button"
          ].value,
          doRedirect: document.getElementById("app-login").attributes[
            "do-redirect"
          ].value
        }
      })
  }).$mount("#app-login");
}

if (document.getElementById("app-registration")) {
  if (process.env.JBS_SITEMODE === 'trade') {
    new Vue({
      mixins: [BasketTimer],
      store,
      router,
      render: h => h(TradeRegistrationForm)
    }).$mount("#app-registration");
  } else {
    new Vue({
      mixins: [BasketTimer],
      store,
      router,
      render: h => h(RegistrationForm)
    }).$mount("#app-registration");
  }
}

if (document.getElementById("app-product-format")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    router,
    render: h =>
      h(ProductFormatFull, {
        props: {
          currentDuty: document.getElementById("app-product-format").attributes[
            "current-duty"
          ].value,
          productId: document.getElementById("app-product-format").attributes[
            "product-id"
          ].value,
          formats: document.getElementById("app-product-format").attributes[
            "formats"
          ].value
        }
      })
  }).$mount("#app-product-format");
}

if (typeof document.getElementsByClassName("app-wishlist-add")[0] !== 'undefined') {
  var els = Array.prototype.slice.call(document.getElementsByClassName("app-wishlist-add"));
  for (var i in els) {
    console.log(els[i]);
    var sku = els[i].attributes[
      "sku"
    ].value;

    new Vue({
      store,
      router,
      render: h =>
        h(WishlistAddButton, {
          props: {
            result: {
              _id: sku
            },
            respondToDutyChange: typeof (els[i].attributes[
              "respond-to-duty-change"
            ]) !== 'undefined'
          }
        })
    }).$mount(els[i]);
  }
}

if (document.getElementById("app-product-format-trade")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    router,
    render: h =>
      h(ProductFormatTrade, {
        props: {
          currentDuty: document.getElementById("app-product-format-trade")
            .attributes["current-duty"].value,
          productId: document.getElementById("app-product-format-trade")
            .attributes["product-id"].value,
          formats: document.getElementById("app-product-format-trade")
            .attributes["formats"].value
        }
      })
  }).$mount("#app-product-format-trade");
}

if (document.getElementById("basket-dot")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    render: h => h(BasketDot)
  }).$mount("#basket-dot");
}

// new Vue({
//   mixins: [BasketTimer],
//   store,
//   render: h => h(AccountMenu)
// }).$mount('#account-menu')
if (document.getElementById("app-common")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    render: h => h(Common)
  }).$mount("#app-common");
}

if (document.getElementById("app-winelist")) {
  new Vue({
    store,
    router: wineListRouter,
    data() {
      return {};
    },
    render: h => h(WineList)
  }).$mount("#app-winelist");
}


if (document.getElementById("app-wishlist")) {
  new Vue({
    store,
    data() {
      return {};
    },
    render: h => h(WishList)
  }).$mount("#app-wishlist");
}

if (document.getElementById("app-technical-info")) {
  new Vue({
    mixins: [BasketTimer],
    store,
    router,
    render: h =>
      h(ProductTechnicalInfo, {
        props: {
          result: JSON.parse(
            document.getElementById("app-technical-info").attributes["result"]
              .value
          ),
          visible: true,
          hideTitle: true
        }
      })
  }).$mount("#app-technical-info");
}


let scrollpos = window.scrollY;
const body = document.querySelector("body");
const header = document.querySelector("header.page-header");
const header_height = header ? header.offsetHeight : 0;

if (header) {
  const add_class_on_scroll = () => {
    header.classList.add("compact");
    body.classList.add("sticky-header");
  };
  const remove_class_on_scroll = () => {
    header.classList.remove("compact");
    body.classList.remove("sticky-header");
  };

  window.addEventListener("scroll", function () {
    scrollpos = window.scrollY;

    if (scrollpos >= header_height) {
      add_class_on_scroll();
    } else {
      remove_class_on_scroll();
    }
  });
}
